module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_121-a161fd76483606cacd6e9d3a96739fc8.png";